import { usePermissions } from '@/hooks/usePermissions';

/**
 * Whether the signed-in partner user administers the partner tenant.
 *
 * Derived from the profile's userTypes rather than probed with a request: the
 * backend gates every partner_admin route itself (CASL), so the client only
 * needs the answer to decide what to render. `isLoading` keeps the admin-only
 * panel from flashing before the profile has resolved.
 */
export function usePartnerAdminAccess(): { isPartnerAdmin: boolean; isLoading: boolean } {
  const { userTypes, isLoading } = usePermissions();

  return { isPartnerAdmin: userTypes.includes('partner_admin'), isLoading };
}
